import { render, staticRenderFns } from "./assetAuth.vue?vue&type=template&id=1900af4b&scoped=true"
import script from "./assetAuth.vue?vue&type=script&lang=js"
export * from "./assetAuth.vue?vue&type=script&lang=js"
import style0 from "./assetAuth.vue?vue&type=style&index=0&id=1900af4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900af4b",
  null
  
)

export default component.exports